<app-public-page-banner></app-public-page-banner>  
<main id="main-content">
  <div #mainContentContainer class="container ontario-row" >
    <div>
      <router-outlet></router-outlet>
    </div>
  </div>
</main>
